// 見積書 新規作成・編集画面
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Paper,
  Snackbar,
  TableContainer,
  useMediaQuery
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import _, { set } from 'lodash';
import React, {
  useCallback,
  useEffect,
  useState,
  useReducer,
  useRef
} from 'react';
import { Redirect, useHistory, useParams, useLocation } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { v4 as uuidv4 } from 'uuid';
import XLSX from 'xlsx';
import { getConstructionDetails } from '../apicalls/construction';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import { getEstimateMasterList } from '../apicalls/esimateMaster';
import {
  createEstimate,
  deleteSingleEstimate,
  getEstimatesDetails,
  registerquotation,
  updateEstimate,
  createWorkingBudget
} from '../apicalls/estimates';
import { savePdf } from '../apicalls/savePdf';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import LoadingComponent from '../components/LoadingComponent';
import {
  estimatePdf,
  customPdf,
  customPdfFormat
} from '../generatePdf/estimatePdf';
import { getPdfData } from '../apicalls/savePdf';
import {
  btnColor,
  isLoggedIn,
  mainBlueColor,
  tenantTaxRuleState,
  userTenant,
  userIdState
} from '../GlobalState';
import { calcTax, formatDatetime } from '../utils/common';
import './List.css';

import thumb1 from '../assets/estimates-thumb-pdf1.png';
import { DatePickerInput } from '../components/atoms';
import {
  ESTIMATE_ITEM_MAX,
  ESTIMATE_TOTAL_ITEM_MAX,
  ESTIMATE_DEFAULT_ITEM_COUNT,
  LOCAL_STORAGE_SAVE_TIME,
  LOCAL_STORAGE_ESTIMATE_KEY,
  LOCAL_STORAGE_NEW_ESTIMATE_KEY,
  DOCUMENT_TYPE,
  EMPLOYEE_TYPE,
  CUSTOM_ESTIMATE_ENABLED_TENANTS,
  EMPLOYEE_STATUS,
  SHOW_AUTHOR_MEMO_USER_KEY
} from '../const/Const';
import { AlertModal } from '../components/editEstimates/AlertModal';
import { CopyModal } from '../components/editEstimates/CopyModal';
import { CustomFormatAlertModal } from '../components/editEstimates/CustomFormatAlert';
import { ChangeModeAlertModal } from '../components/editEstimates/ChangeModeAlert';
import { DocumentDeleteModal } from '../components/DocumentDeleteModal';
import SaveConfirmModal from '../components/editEstimates/SaveConfirmationModal';
import {
  createExcelExportFormat,
  getEstimateStatusString,
  getCopyToList,
  instantiateEstimateItemFromBase,
  handleTextValidation,
  createDefaultEstimateItems
} from '../utils/estimate';
import {
  TEstimateBaseItem,
  TEstimateItem,
  TNewItem,
  TNewSecondItem,
  TNewThirdItem,
  TNewFourthItem,
  TNewEstimateItem,
  TViewMode,
  CopyModalState,
  CopyModalAction,
  TSaveConfirmModalState
} from '../types/estimate/estimate';
import { TTenant } from '../types/common';
import { progressFlgState } from '../GlobalState';
import { log } from '../utils';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { TTopicPathState } from '../components/topicPath/type/Type';
import { FORMAT_TYPE_ID } from '../const/Const';
import { fetchAdditionalCost } from '../utils/Estimates';
import HelpIcon from '@material-ui/icons/Help';
import { TAX_RULE } from '../const/Const';
import { useStyles } from '../components/editEstimates/Style';

import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';
import { getStaffSelectOptions } from '../utils/getStaffSelectOptions';
import { StaffData } from '../types/staffData';
import SummaryTable from '../components/editEstimates/EstimateItems/SummaryTable';
import EstimateItems from '../components/editEstimates/EstimateItems';
import {
  getCompanyLogo,
  getCompanyStamp
} from '../apicalls/companyInformation';

const PAGE_TRANSITION_ALLOW_LIST = [
  /^\/$/, // ログアウト
  /^\/change\/password$/, // /change/password (パスワード変更)
  /^\/working_budget/, // /working_budget (実行予算作成)
  /^\/estimates\/[^/]+\/preview$/, // /estimates/:id/preview (プレビュー)
  /^\/estimates\/[^/]+\/edit$/, // /estimates/:id/edit (見積書編集)
  /^\/merchandise-orders\/create$/, // /merchandise-orders/create (商品発注書作成)
  /^\/outsource-orders\/create$/, // /merchandise-orders/create (外注発注書作成)
  /^\/site-contacts\/create$/ // /site-contact-orders/create (現場連絡表作成)
];

export type TSetLocalStorage = (
  key:
    | 'code'
    | 'constructSub'
    | 'status'
    | 'salesUser'
    | 'selectedDate'
    | 'accumulationCharge'
    | 'estimateConditions'
    | 'constructDays'
    | 'clientName'
    | 'honorificTitle'
    | 'contractorName'
    | 'clientChargeName'
    | 'expireDate'
    | 'termsOfTrade'
    | 'remarks'
    | 'estimateItemList',
  value: string
) => void;

export const EditEstimates: React.FC = () => {
  const baseAggregateResults = {
    sellingPriceTotal: 0,
    taxTotal: 0,
    billingTotal: 0,
    costPriceTotal: 0,
    grossProfitTotal: 0,
    grossProfitMarginTotal: 0,
    dailyUnitPrice: 0
  };

  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  // テナントごとの消費税の小数点以下計算ルール
  const [tenantTaxRule] = useRecoilState(tenantTaxRuleState);
  // 見積ごとの消費税の小数点以下計算ルール
  const [taxRule, setTaxRule] = useState<number>(tenantTaxRule);

  const handleTaxRuleChange = (newTaxRule: number) => {
    setTaxRule(newTaxRule);
  };

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [userData, setUserData] = useState([]);
  const userTenantData = useRecoilValue<TTenant | undefined>(userTenant);

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [isComposing, setIsComposing] = useState(false);

  const [viewMode, setViewMode] = React.useState<TViewMode>('階層モード');
  const [tableSized, setTableSized] = useState<number>(100);

  const [status, setStatus] = useState<number>(1);
  const [selectedDateValue, setSelectedDateValue] = useState('');
  const [salesUser, setSalesUser] = useState<number>(0);
  const [accumulationCharge, setAccumulationCharge] = useState<number>(0);
  const [createduserId, setcreateduserId] = useState<number>(0);
  const [constructId, setConstructId] = useState<number>(0);
  const [constructSub, setConstructSub] = useState('');
  const [remarks, setRemarks] = useState('');
  const [constructDays, setConstructDays] = useState(0);
  const [clientName, setClientName] = useState('');
  const [honorificTitle, setHonorificTitle] = useState('御中');
  const [contractorName, setContractorName] = useState('');
  const [clientChargeName, setClientChargeName] = useState('');
  const [expireDate, setExpireDate] = useState('');
  const [termsOfTrade, setTermsOfTrade] = useState('');
  const [createdUser, setCreatedUser] = useState('');
  const [updatedUser, setUpdatedUser] = useState('');
  const [createdAt, setCreatedAt] = useState('');
  const [updatedAt, setUpdatedAt] = useState('');
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [estimateItemList, setEstimateItemList] = useState<TEstimateItem[]>([]);
  const [copyItem, setCopyItem] =
    useState<TEstimateItem | undefined>(undefined);
  const [aggregateResults, setAggregateResults] =
    useState(baseAggregateResults);
  const [name, setName] = useState('');
  const [spec, setSpec] = useState('');
  const [authorMemo, setAuthorMemo] = useState('');
  //社内メモを表示するかどうかをローカルストレージに保存する際のkey
  const setAuthorMemoUserKey = SHOW_AUTHOR_MEMO_USER_KEY + userIdState;
  // ローカルストレージから社内メモを表示するかどうかを取得
  const storedShowAuthorMemo = localStorage.getItem(setAuthorMemoUserKey);
  const [showAuthorMemo, setShowAuthorMemo] = useState(
    storedShowAuthorMemo ? JSON.parse(storedShowAuthorMemo) : true
  );
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setShowAuthorMemo(checked);
    localStorage.setItem(setAuthorMemoUserKey, JSON.stringify(checked));
  };

  const [tax, setTax] = useState(0);

  const [itemTotalCount, setItemTotalCount] = useState<number>(0);

  const [estimateConditions, setEstimateConditions] = useState('');
  // 三階層以下が存在するかどうかの判定
  const [hasThirdLayer, setHasThirdLayer] = useState<boolean>(true);
  // カスタムフォーマット非対応時のアラート
  const [customFormatAlertModal, setCustomFormatAlertModal] =
    useState<boolean>(false);
  // 全体モード推奨項目数オーバーのアラート
  const [changeModeAlertModal, setChangeModeAlertModal] =
    useState<boolean>(false);
  // ローディング
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  // 帳票削除アラート
  const [documentDeleteModal, setDocumentDeleteModal] =
    useState<boolean>(false);
  const [openImportEstimateMasterDialog, setOpenImportEstimateMasterDialog] =
    useState(false);

  const handleCloseSelectFormatDialog = () => {
    setOpenSelectFormatDialog(false);
  };

  const [openSelectFormatDialog, setOpenSelectFormatDialog] = useState(false);

  const [selectedFormatId, setSelectedFormatId] = useState<number | null>(null);

  const [selectedFormatIdOnModal, setSelectedFormatIdOnModal] =
    useState<number | null>(null);

  const [estimateMasterItems, setEstimateMasterItems] = useState([]);
  const [estimateMasterItemsSearch, setEstimateMasterItemsSearch] = useState(
    []
  );
  const [dialogLoading, setDialogLoading] = useState(false);

  const [loading, setLoading] = useState(true);
  const [encryptedJsonData, setEncryptedJsonData] = useState<any>(null);
  const [showLinearProgress, setShowLinearProgress] = useState(false);
  const [estimateDetailData, setEstimateDetailData] = useState<any>({});

  const [initialSalesUserData, setInitialSalesUserData] =
    useState<StaffData | null>(null);
  const [initialAccountantUserData, setInitialAccountantUserData] =
    useState<StaffData | null>(null);

  const [customFormats, setCustomFormats] = useState<any>([]);
  const [documentNumber, setDocumentNumber] = useState('');
  // ローカルストレージの内容を反映するかの確認モーダルの表示フラグ
  const [reflectModal, setReflectModal] = useState<boolean>(false);
  // 保存時間
  const [saveTime, setSaveTime] = useState<string | null>('');
  // 項目のコピーモーダル状態
  const [copyModalState, copyModalDispatch] = useReducer<
    (state: CopyModalState, action: CopyModalAction) => CopyModalState
  >(
    (state, action) => {
      switch (action.type) {
        case 'open':
          return { type: 'open', copyItem: action.copyItem };
        case 'close':
          return { type: 'closed' };
        case 'submit':
          return {
            type: 'submitted',
            copyTo: action.copyTo,
            copyItem: action.copyItem,
            allCopy: action.allCopy
          };
        default:
          return state;
      }
    },
    { type: 'closed' }
  );
  const [saveConfirmModalState, setSaveConfirmModalState] =
    useState<TSaveConfirmModalState>({ type: 'closed' });

  const [tenantId, setTenantId] = useState<null | number>(null);
  const [customFormatPdf, setCustomFormatPdf] = useState<null | string[]>(null);
  const [customFormatThumb, setCustomFormatThumb] =
    useState<null | string>(null);
  const [isCustomFormat, setIsCustomFormat] = useState<boolean>(false);
  const mode = (process.env.REACT_APP_MODE ||
    'dev') as keyof typeof CUSTOM_ESTIMATE_ENABLED_TENANTS;

  // 追加原価
  const [additionalParam, setAdditionalParam] = useState({
    id: 0,
    additionalCost: 0,
    finalGrossProfitMargin: 0
  });

  const [outPutPdf, setOutPutPdf] = useState(false);

  const outPutCheck = () => {
    if (outPutPdf) {
      setOutPutPdf(false);
    } else {
      setOutPutPdf(true);
    }
  };

  const [displayItemNumber, setDisplayItemNumber] = useState(true);
  const handleDisplayItemNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDisplayItemNumber(event.target.checked);
  };

  /**
   * エクセルファイルのダウンロード
   */
  const downloadExcel = () => {
    setProgressFlg(true);
    // ステータスを取得
    const statusString: any = getEstimateStatusString(status);
    // 営業担当者を取得
    const salesUserData: any =
      userData &&
      userData.find(
        (user: { id: number; name: string }) => user.id === salesUser
      );
    // 積算担当者を取得
    const accumulationUserData: any =
      userData &&
      userData.find(
        (user: { id: number; name: string }) => user.id === accumulationCharge
      );
    // 見積提出日のフォーマットを変更
    const SubmitDate: any = formatDatetime(selectedDate, 'YYYY年MM月DD日');

    // エクセル出力用のフォーマットを作成する
    const data: any = createExcelExportFormat(
      documentNumber,
      statusString,
      salesUserData.name,
      accumulationUserData.name,
      SubmitDate,
      constructSub,
      constructDays,
      clientName,
      estimateConditions,
      contractorName,
      remarks,
      createdUser,
      createdAt,
      updatedUser,
      updatedAt,
      totalPrice,
      estimateItemList
    );

    const excelData: any = {
      見積書情報: data.data_main,
      見積書項目: data.data_items
    };
    // Make Workbook of excel
    const wb = XLSX.utils.book_new();
    for (const key in excelData) {
      // Export json to Worksheet of Excel ( only array possible )
      const jsonToSheet = XLSX.utils.json_to_sheet(excelData[key]);
      // Add Worksheet to Workbook ( workbook contains one or more worksheets )
      XLSX.utils.book_append_sheet(wb, jsonToSheet, key);
    }
    // Export excel file
    XLSX.writeFile(wb, `見積.xlsx`);
    setProgressFlg(false);
  };

  /**
   * 見積書提出日
   */
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setSelectedDateValue(finaldate);
    // ローカルストレージへ保存
    setLocalStorage('selectedDate', finaldate);
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const handleCloseImportEstimateMasterDialog = () => {
    setOpenImportEstimateMasterDialog(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const matches2 = useMediaQuery('(min-width:900px)');
  const classes = useStyles({ matches2, tableSized, mainColor });
  const history = useHistory<any>();
  const unblockPageTransitionRef = useRef<any>(null);
  const params: any = useParams();
  const location: any = useLocation();

  // ローカルストレージで保存する際のキー(見積書用)
  // 新規作成：estimate_construction_id_工事ID / 編集：estimate_見積書ID
  const setKey = params.id
    ? LOCAL_STORAGE_ESTIMATE_KEY + params.id
    : LOCAL_STORAGE_NEW_ESTIMATE_KEY + history.location.state.constructId;

  const backToPreviousPage = useCallback(() => {
    if (history.location.state.params || history.location.state.tabs) {
      // 暫定対応:
      //   stateにどこから遷移したかを記録しているが、本来historyのpushやreplaceを正しく使えば必要ないはず
      // 戻る先を判定する
      if (history.location.state.previouspath === 'to_construction') {
        // 工事一覧画面へ
        history.replace(
          `/constructions_document/${history.location.state.constructId}/edit`,
          history.location.state
        );
      } else {
        // 見積もり一覧画面へ
        history.push('/estimates', history.location.state);
      }
    } else {
      if (history.location.state?.currentPage) {
        history.push('/estimates', history.location.state);
      } else {
        history.goBack();
      }
    }
  }, [history]);

  /**
   * 社員取得
   */
  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1, 0, EMPLOYEE_TYPE['INSIDE_EMPLOYEE']).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setUserData(data.data);
            }
          }
        }
      }
    );
  }, [changeLoggedInData]);

  const getListOfEstimateItems = useCallback(
    (items: any) => {
      setListOfItems(items);
      // getAggregateResults();
      // 無限ループになるためeslint disable
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [changeLoggedInData, history.location.state]
  );
  //選択中の見積もり書番
  const { id: estimate_id }: any = useParams();
  const getTheDetailsOfEstimateList = (
    newEstimateId: any = null,
    goPreview: boolean = false,
    excelExport: boolean = false
  ) => {
    getEstimatesDetails(newEstimateId ? newEstimateId : estimate_id).then(
      async data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
            setProgressFlg(false);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
              setProgressFlg(false);
            } else {
              if (data.data.sales_user_status === EMPLOYEE_STATUS.INACTIVE) {
                const salesUserData: StaffData = {
                  name: data.data.sales_user_name,
                  id: data.data.sales_user_id
                };
                setInitialSalesUserData(salesUserData);
              } else {
                setInitialSalesUserData(null);
              }

              if (
                data.data.accountant_user_status === EMPLOYEE_STATUS.INACTIVE
              ) {
                const accountantUserData: StaffData = {
                  name: data.data.accountant_user_name,
                  id: data.data.accountant_user_id
                };
                setInitialAccountantUserData(accountantUserData);
              } else {
                setInitialAccountantUserData(null);
              }
              if (newEstimateId) {
                //code for checking whether the data is updated or not, if any data is updated new pdf will be generated and uploaded
                let isDataUpdated: boolean = false;

                if (estimateDetailData['items']) {
                  if (
                    estimateDetailData['items'].length !==
                    data.data['items'].length
                  ) {
                    isDataUpdated = true;
                  } else {
                    for (
                      let i = 0;
                      i < estimateDetailData['items'].length;
                      i++
                    ) {
                      if (
                        estimateDetailData['items'][i].name !==
                        data.data['items'][i].name
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].spec !==
                        data.data['items'][i].spec
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].quantity !==
                        data.data['items'][i].quantity
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].unit_id !==
                        data.data['items'][i].unit_id
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].cost_quantity !==
                        data.data['items'][i].cost_quantity
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].cost_unit_id !==
                        data.data['items'][i].cost_unit_id
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].selling_unit_price !==
                        data.data['items'][i].selling_unit_price
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].cost_unit_price !==
                        data.data['items'][i].cost_unit_price
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].remarks !==
                        data.data['items'][i].remarks
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].author_memo !==
                        data.data['items'][i].author_memo
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].parent_item_id !==
                        data.data['items'][i].parent_item_id
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].layer !==
                        data.data['items'][i].layer
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        estimateDetailData['items'][i].has_under_layer_flg !==
                        data.data['items'][i].has_under_layer_flg
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                    }
                  }
                }
                if (isDataUpdated === false) {
                  let oldData = Object.keys(estimateDetailData);
                  let updatedData = Object.keys(data.data);
                  oldData = oldData.filter(
                    (char: any, aa: any) => char !== 'items'
                  );
                  oldData = oldData.filter(
                    (char: any, aa: any) => char !== 'updated_user'
                  );
                  oldData = oldData.filter(
                    (char: any, aa: any) => char !== 'updated_user_id'
                  );
                  oldData = oldData.filter(
                    (char: any, aa: any) => char !== 'updated_at'
                  );

                  updatedData = updatedData.filter(
                    (char: any, aa: any) => char !== 'items'
                  );
                  updatedData = updatedData.filter(
                    (char: any, aa: any) => char !== 'updated_user'
                  );
                  updatedData = updatedData.filter(
                    (char: any, aa: any) => char !== 'updated_user_id'
                  );
                  updatedData = updatedData.filter(
                    (char: any, aa: any) => char !== 'updated_at'
                  );

                  if (oldData.length !== updatedData.length) {
                    isDataUpdated = true;
                  } else {
                    for (let el of updatedData) {
                      if (estimateDetailData[el] !== data.data[el]) {
                        isDataUpdated = true;
                        break;
                      }
                    }
                  }
                }
                if (isDataUpdated) {
                  // 内容が更新されている場合はS3にアップロード
                  console.log('isDataUpdated', isDataUpdated);
                  uploadEstimatePdf(
                    data.data,
                    newEstimateId,
                    goPreview,
                    excelExport
                  );
                } else {
                  setShowLinearProgress(false);
                  setProgressFlg(false);
                  setOpenSuccess(true);

                  //previouspathを渡す（暫定対応）
                  if (goPreview === true) {
                    history.replace(`/estimates/${newEstimateId}/preview`, {
                      rowId: history.location.state.rowId,
                      previouspath: history.location.state.previouspath,
                      params: history.location.state.params,
                      tabs: history.location.state.tabs,
                      newEstimateId: newEstimateId,
                      constructId: history.location.state.constructId
                    });
                  }
                  // エクセルエクスポート押下時
                  if (excelExport === true) {
                    downloadExcel();
                  }
                }
              }

              setEstimateDetailData(data.data);
              setTax(data.data.tax_rate);
              setStatus(data.data.status);
              setSelectedDateValue(data.data.submission_date);
              if (data.data.submission_date !== '') {
                setSelectedDate(new Date(data.data.submission_date));
              }
              setSalesUser(data.data.sales_user_id);
              setOutPutPdf(data.data.output_pdf);
              setDisplayItemNumber(data.data.display_item_number_in_pdf);
              setAccumulationCharge(data.data.accountant_user_id);
              setRemarks(data.data.summary);
              setConstructId(data.data.construct_id);
              setConstructDays(data.data.construct_days);
              setClientName(data.data.client_name);
              setHonorificTitle(data.data.honorific_title);
              setcreateduserId(data.data.created_user_id);
              setContractorName(data.data.contractor_name);
              setClientChargeName(data.data.client_charge_name);
              setExpireDate(data.data.expire_date);
              setTermsOfTrade(data.data.terms_of_trade);
              setConstructSub(data.data.construct_sub);

              setCreatedUser(data.data.created_user);
              setCreatedAt(data.data.created_at);
              setUpdatedUser(data.data.updated_user);
              setUpdatedAt(data.data.updated_at);
              getListOfEstimateItems(data.data.items); //明細を取得し格納
              setEstimateConditions(data.data.estimate_conditions);
              setSelectedFormatId(data.data.custom_format_id); // カスタム見積書を利用する場合、テナントidを格納
              setSelectedFormatIdOnModal(data.data.custom_format_id);
              setDocumentNumber(data.data.code);
              setLoading(false);
              setTaxRule(
                data.data && data.data.tax_rule !== null
                  ? data.data.tax_rule
                  : tenantTaxRule
              );
              setDisplayItemNumber(data.data.display_item_number_in_pdf);
              setTenantId(data.data.tenant_id);
              if (
                CUSTOM_ESTIMATE_ENABLED_TENANTS[mode].includes(
                  data.data.tenant_id
                )
              ) {
                const customFormat = (await customPdfFormat(
                  data.data.company_logo,
                  data.data.company_logo_format,
                  data.data.company_logo_width,
                  data.data.company_logo_height,
                  data.data.company_stamp,
                  data.data.company_stamp_format,
                  data.data.tenant_id,
                  true
                )) as {
                  base64Strings: string[];
                  pngDataUrl: string;
                };
                setCustomFormatPdf(customFormat.base64Strings);
                setCustomFormatThumb(customFormat.pngDataUrl);
                setIsCustomFormat(true);
              }
            }
          }
        }
      }
    );
  };

  //upload pdf
  const uploadEstimatePdf = async (
    pdfData: any,
    newEstimateId: number,
    goPreview: boolean,
    excelExport: boolean
  ) => {
    let blob = null;
    if (pdfData.custom_format_id) {
      blob = await customPdf(pdfData, customFormatPdf);
    } else if (pdfData.document_id) {
      blob = await getPdfData(pdfData.document_id);
    } else {
      blob = await estimatePdf(pdfData);
    }

    const formData: any = new FormData();
    formData.append('document_type_id', JSON.stringify(DOCUMENT_TYPE.ESTIMATE));
    formData.append('estimate_id', JSON.stringify(newEstimateId));
    formData.append('file_obj', blob);

    savePdf(formData).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setProgressFlg(false);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setProgressFlg(false);
            setOpen(true);
          } else {
            setShowLinearProgress(false);
            setProgressFlg(false);
            setOpenSuccess(true);
            // プレビューボタン押下時
            // 書類一覧→書類詳細の場合はto_estimate,工事詳細→書類詳細の場合はto_constructionを返す
            if (goPreview === true) {
              history.replace(`/estimates/${newEstimateId}/preview`, {
                rowId: history.location.state.rowId,
                previouspath: history.location.state.previouspath,
                tabs: history.location.state.tabs,
                params: history.location.state.params,
                newEstimateId: newEstimateId,
                constructId: history.location.state.constructId
              });
            } else {
              // エクセルエクスポート押下時
              if (excelExport === true) {
                downloadExcel();
              }
              // 新規作成時
              if (!params.id) {
                history.replace(`/estimates/${newEstimateId}/edit`, {
                  state: newEstimateId
                });
              }
            }
          }
        }
      }
    });
  };

  const initializeEstimate = useCallback(() => {
    setConstructId(history.location.state.constructId);
    getConstructionDetails(history.location.state.constructId).then(
      async data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setConstructSub(data.data.name);
              setConstructId(history.location.state.constructId);
              setClientName(data.data.client_name);
              setContractorName(data.data.contractor_name);
              setClientChargeName(data.data.client_charge_name);
              setExpireDate('見積発行から1ヶ月以内');
              setTermsOfTrade('ご入金は銀行振込でお願い致します。');
              setEstimateItemList(
                createDefaultEstimateItems(
                  1,
                  userTenantData?.estimate_default_items
                    ? ESTIMATE_DEFAULT_ITEM_COUNT
                    : 1
                )
              );
              setLoading(false);
              if (data.data.sales_staff_id) {
                setSalesUser(data.data.sales_staff_id);
              } else {
                setSalesUser(data.data.first_in_charge_id);
              }
              if (data.data.accumulation_charge_id) {
                setAccumulationCharge(data.data.accumulation_charge_id);
              } else {
                setAccumulationCharge(data.data.first_in_charge_id);
              }
              setTenantId(data.data.tenant_id);
              // カスタム見積書のサムネ作成
              if (
                CUSTOM_ESTIMATE_ENABLED_TENANTS[mode].includes(
                  data.data.tenant_id
                )
              ) {
                const companyLogo = await getCompanyLogo(
                  data.data.tenant_id
                ).then(data => {
                  if (data === 'Not logged in!') {
                    changeLoggedInData('Not logged in!');
                  } else {
                    if (typeof data === 'string') {
                      setErrorMessage(data);
                      setOpen(true);
                    } else {
                      if (data.error) {
                        setErrorMessage(data.error);
                        setOpen(true);
                      } else {
                        return data.data;
                      }
                    }
                  }
                });
                const companyStamp = await getCompanyStamp(
                  data.data.tenant_id
                ).then(data => {
                  if (data === 'Not logged in!') {
                    changeLoggedInData('Not logged in!');
                  } else {
                    if (typeof data === 'string') {
                      setErrorMessage(data);
                      setOpen(true);
                    } else {
                      if (data.error) {
                        setErrorMessage(data.error);
                        setOpen(true);
                      } else {
                        return data.data;
                      }
                    }
                  }
                });

                const customFormat = (await customPdfFormat(
                  companyLogo.data,
                  companyLogo.file_format,
                  companyLogo.width,
                  companyLogo.height,
                  companyStamp.data,
                  companyStamp.file_format,
                  tenantId,
                  true
                )) as {
                  base64Strings: string[];
                  pngDataUrl: string;
                };
                setCustomFormatPdf(customFormat.base64Strings);
                setCustomFormatThumb(customFormat.pngDataUrl);
                setIsCustomFormat(true);
              }
            }
          }
        }
      }
    ); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeLoggedInData, history.location.state.rowId]);

  /**
   * 見積書マスタを取得
   */
  useEffect(() => {
    if (openImportEstimateMasterDialog) {
      setDialogLoading(true);
      getEstimateMasterList(name.trim(), spec.trim(), authorMemo.trim()).then(
        data => {
          if (data === 'Not logged in!') {
            changeLoggedInData('Not logged in!');
          } else {
            if (typeof data === 'string') {
              setErrorMessage(data);
              setOpen(true);
            } else {
              if (data.error) {
                setErrorMessage(data.error);
                setOpen(true);
              } else {
                data.data.forEach((obj: any) => {
                  obj.importFlag = false;
                });
                setEstimateMasterItems(data.data);
                setEstimateMasterItemsSearch(data.data);
                setDialogLoading(false);
              }
            }
          }
        }
      );
    }
  }, [openImportEstimateMasterDialog, changeLoggedInData]);

  /**
   * 見積書マスタ検索
   */
  const searchEstimateMasters = () => {
    const searchResults = estimateMasterItemsSearch.filter((data: any) => {
      return (
        data.name.toUpperCase().includes(name.toUpperCase()) &&
        data.spec.toUpperCase().includes(spec.toUpperCase()) &&
        data.author_memo.toUpperCase().includes(authorMemo.toUpperCase())
      );
    });
    setEstimateMasterItems(searchResults);
  };

  useEffect(() => {
    searchEstimateMasters();
  }, [name, spec, authorMemo]);

  /**
   * 明細のバリデーション
   */
  const itemDetailValidation = (item: any, name: string) => {
    if (isNaN(item.sellingUnitPrice)) {
      setErrorMessage(`正しい単価を入力してください。`);
      existsError = true;
      setOpen(true);
      return;
    } else if (isNaN(item.costUnitPrice)) {
      setErrorMessage(`正しい原価単価を入力してください。`);
      existsError = true;
      setOpen(true);
      return;
    }
  };

  /**
   * 実行予算
   */
  const onClickWorkingBudget = (workingBudgetId: number) => {
    if (workingBudgetId != 0) {
      // 見積を更新して実行予算へ画面遷移
      updateOrCreateEstimateDetails(
        false,
        false,
        null,
        (estimateId: number) => {
          setShowLinearProgress(false);
          setProgressFlg(false);
          history.push(`/working_budget?id=${workingBudgetId}`);
        }
      );
    } else {
      // 見積を保存/更新して実行予算を作成、画面遷移
      updateOrCreateEstimateDetails(
        false,
        false,
        null,
        (estimateId: number) => {
          createWorkingBudget(estimateId).then(data => {
            setShowLinearProgress(false);
            setProgressFlg(false);
            history.push(`/working_budget?id=${data.data}`);
          });
        }
      );
    }
  };

  /**
   * 見積書作成・更新
   */
  let existsError = false;
  const updateOrCreateEstimateDetails = (
    goPreview: boolean = false,
    excelExport: boolean = false,
    draggedEstimateList: any = null,
    callback?: (estimateId: number) => void | (() => void)
  ) => {
    // 操作ログ出力のためにボタンの種別を取得
    const press_btn: string = goPreview
      ? 'preview'
      : excelExport
      ? 'excelExport'
      : 'save';
    if (params.id && !documentNumber) {
      // 編集時は見積書番号必須
      setErrorMessage('見積書番号を入力してください。');
      existsError = true;
      setOpen(true);
    } else if (status === 0 || !status) {
      setErrorMessage('ステータスを選択してください。');
      existsError = true;
      setOpen(true);
    } else if (selectedDate === null) {
      setErrorMessage('見積提出日を入力してください。');
      existsError = true;
      setOpen(true);
    } else if (!salesUser || salesUser === 0) {
      setErrorMessage('営業担当を選択してください。');
      existsError = true;
      setOpen(true);
    } else if (!accumulationCharge || accumulationCharge === 0) {
      setErrorMessage('積算担当を選択してください。');
      existsError = true;
      setOpen(true);
    } else if (estimateConditions.replace(/\r?\n|\r/g, '').length > 135) {
      setErrorMessage('御見積条件は135文字以内で入力してください。');
      existsError = true;
      setOpen(true);
    } else if (estimateConditions.split(/\n/).length > 8) {
      setErrorMessage('御見積条件は8行以内で入力してください。');
      existsError = true;
      setOpen(true);
    } else if (remarks.length > 115) {
      setErrorMessage('摘要は115文字以内で入力してください。');
      existsError = true;
      setOpen(true);
    } else if (remarks.split(/\n/).length > 4) {
      setErrorMessage('摘要は4行以内で入力してください。');
      existsError = true;
      setOpen(true);
    } else if (expireDate.length > 24) {
      setErrorMessage('見積有効期限は24文字以内で入力してください。');
      existsError = true;
      setOpen(true);
    } else if (termsOfTrade.length > 24) {
      setErrorMessage('取引条件は24文字以内で入力してください。');
      existsError = true;
      setOpen(true);
    } else {
      if (draggedEstimateList !== null) {
        draggedEstimateList.forEach((item: any) => {
          itemDetailValidation(item, item.name);
          if (item.hasUnderLayerFlg && item.childItems.length > 0) {
            item.childItems.forEach((secondItem: any) => {
              itemDetailValidation(secondItem, item.name);
              if (
                secondItem.hasUnderLayerFlg &&
                secondItem.childItems.length > 0
              ) {
                secondItem.childItems.forEach((thirdItem: any) => {
                  itemDetailValidation(thirdItem, secondItem.name);
                  if (
                    thirdItem.hasUnderLayerFlg &&
                    thirdItem.childItems.length > 0
                  ) {
                    thirdItem.childItems.forEach((fourthItem: any) => {
                      itemDetailValidation(fourthItem, thirdItem.name);
                      if (
                        fourthItem.hasUnderLayerFlg &&
                        fourthItem.childItems.length > 0
                      ) {
                        fourthItem.childItems.forEach((fifthItem: any) => {
                          itemDetailValidation(fifthItem, fourthItem.name);
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      } else {
        estimateItemList.forEach((item: any) => {
          itemDetailValidation(item, item.name);
          if (item.hasUnderLayerFlg && item.childItems.length > 0) {
            item.childItems.forEach((secondItem: any) => {
              itemDetailValidation(secondItem, item.name);
              if (
                secondItem.hasUnderLayerFlg &&
                secondItem.childItems.length > 0
              ) {
                secondItem.childItems.forEach((thirdItem: any) => {
                  itemDetailValidation(thirdItem, secondItem.name);
                  if (
                    thirdItem.hasUnderLayerFlg &&
                    thirdItem.childItems.length > 0
                  ) {
                    thirdItem.childItems.forEach((fourthItem: any) => {
                      itemDetailValidation(fourthItem, thirdItem.name);
                      if (
                        fourthItem.hasUnderLayerFlg &&
                        fourthItem.childItems.length > 0
                      ) {
                        fourthItem.childItems.forEach((fifthItem: any) => {
                          itemDetailValidation(fifthItem, fourthItem.name);
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
      if (existsError === false) {
        let newEstimateItemList: any = [];
        if (draggedEstimateList !== null) {
          newEstimateItemList = draggedEstimateList;
        } else {
          newEstimateItemList = estimateItemList;
        }
        const estimateItemListToSave: TNewItem[] = [];
        newEstimateItemList.forEach((item: TNewItem) => {
          const estimateSecondItemListToSave: TNewSecondItem[] = [];
          if (item.hasUnderLayerFlg && item.childItems.length > 0) {
            item.childItems.forEach((secondItem: TNewSecondItem) => {
              const estimateThirdItemListToSave: TNewThirdItem[] = [];
              if (
                secondItem.hasUnderLayerFlg &&
                secondItem.childItems.length > 0
              ) {
                secondItem.childItems.forEach((thirdItem: TNewThirdItem) => {
                  const estimateFourthItemListToSave: TNewFourthItem[] = [];
                  if (
                    thirdItem.hasUnderLayerFlg &&
                    thirdItem.childItems.length > 0
                  ) {
                    thirdItem.childItems.forEach(
                      (fourthItem: TNewFourthItem) => {
                        const estimateFifthItemListToSave: TNewEstimateItem[] =
                          [];
                        if (
                          fourthItem.hasUnderLayerFlg &&
                          fourthItem.childItems.length > 0
                        ) {
                          fourthItem.childItems.forEach(
                            (fifthItem: TNewEstimateItem) => {
                              estimateFifthItemListToSave.push({
                                id:
                                  typeof fifthItem.id === 'number' &&
                                  fifthItem.id,
                                name: fifthItem.name,
                                spec: fifthItem.spec,
                                order_id: fifthItem.order_id,
                                quantity: fifthItem.quantity
                                  ? fifthItem.quantity
                                  : fifthItem.quantity === 0
                                  ? 0
                                  : 0,
                                unit_id: fifthItem.unitId,
                                selling_unit_price: Number(
                                  fifthItem.sellingUnitPrice
                                ), // 空文字の可能性があるためNumberにパース
                                cost_unit_price: Number(
                                  fifthItem.costUnitPrice
                                ), // 空文字の可能性があるためNumberにパース
                                remarks: fifthItem.remarks,
                                author_memo: fifthItem.author_memo,
                                cost_quantity: fifthItem.costQuantity
                                  ? fifthItem.costQuantity
                                  : fifthItem.costQuantity === 0
                                  ? 0
                                  : 0,
                                cost_unit_id: fifthItem.costUnitId,
                                layer: fifthItem.layer,
                                has_under_layer_flg: fifthItem.hasUnderLayerFlg
                              });
                            }
                          );
                        }
                        estimateFourthItemListToSave.push({
                          id:
                            typeof fourthItem.id === 'number' && fourthItem.id,
                          name: fourthItem.name,
                          spec: fourthItem.spec,
                          order_id: fourthItem.order_id,
                          quantity: fourthItem.quantity
                            ? fourthItem.quantity
                            : fourthItem.quantity === 0
                            ? 0
                            : 0,
                          unit_id: fourthItem.unitId,
                          selling_unit_price: Number(
                            fourthItem.sellingUnitPrice
                          ), // 空文字の可能性があるためNumberにパース
                          cost_unit_price: Number(fourthItem.costUnitPrice), // 空文字の可能性があるためNumberにパース
                          remarks: fourthItem.remarks,
                          author_memo: fourthItem.author_memo,
                          cost_quantity: fourthItem.costQuantity
                            ? fourthItem.costQuantity
                            : fourthItem.costQuantity === 0
                            ? 0
                            : 0,
                          cost_unit_id: fourthItem.costUnitId,
                          layer: fourthItem.layer,
                          has_under_layer_flg: fourthItem.hasUnderLayerFlg,
                          fifth_items: estimateFifthItemListToSave
                        });
                      }
                    );
                  }
                  estimateThirdItemListToSave.push({
                    id: typeof thirdItem.id === 'number' && thirdItem.id,
                    name: thirdItem.name,
                    spec: thirdItem.spec,
                    order_id: thirdItem.order_id,
                    quantity: thirdItem.quantity
                      ? thirdItem.quantity
                      : thirdItem.quantity === 0
                      ? 0
                      : 0,
                    unit_id: thirdItem.unitId,
                    selling_unit_price: Number(thirdItem.sellingUnitPrice), // 空文字の可能性があるためNumberにパース
                    cost_unit_price: Number(thirdItem.costUnitPrice), // 空文字の可能性があるためNumberにパース
                    remarks: thirdItem.remarks,
                    author_memo: thirdItem.author_memo,
                    cost_quantity: thirdItem.costQuantity
                      ? thirdItem.costQuantity
                      : thirdItem.costQuantity === 0
                      ? 0
                      : 0,
                    cost_unit_id: thirdItem.costUnitId,
                    layer: thirdItem.layer,
                    has_under_layer_flg: thirdItem.hasUnderLayerFlg,
                    fourth_items: estimateFourthItemListToSave
                  });
                });
              }
              estimateSecondItemListToSave.push({
                id: typeof secondItem.id === 'number' && secondItem.id,
                name: secondItem.name,
                spec: secondItem.spec,
                order_id: secondItem.order_id,
                quantity: secondItem.quantity
                  ? secondItem.quantity
                  : secondItem.quantity === 0
                  ? 0
                  : 0,
                unit_id: secondItem.unitId,
                selling_unit_price: Number(secondItem.sellingUnitPrice), // 空文字の可能性があるためNumberにパース
                cost_unit_price: Number(secondItem.costUnitPrice), // 空文字の可能性があるためNumberにパース
                remarks: secondItem.remarks,
                author_memo: secondItem.author_memo,
                cost_quantity: secondItem.costQuantity
                  ? secondItem.costQuantity
                  : secondItem.costQuantity === 0
                  ? 0
                  : 0,
                cost_unit_id: secondItem.costUnitId,
                layer: secondItem.layer,
                has_under_layer_flg: secondItem.hasUnderLayerFlg,
                third_items: estimateThirdItemListToSave
              });
            });
          }
          estimateItemListToSave.push({
            id: typeof item.id === 'number' && item.id,
            name: item.name,
            spec: item.spec,
            order_id: item.order_id ? item.order_id : -1,
            quantity: item.quantity
              ? item.quantity
              : item.quantity === 0
              ? 0
              : 0,
            unit_id: item.unitId,
            cost_quantity: item.costQuantity
              ? item.costQuantity
              : item.costQuantity === 0
              ? 0
              : 0,
            cost_unit_id: item.costUnitId,
            selling_unit_price: Number(item.sellingUnitPrice), // 空文字の可能性があるためNumberにパース
            cost_unit_price: Number(item.costUnitPrice), // 空文字の可能性があるためNumberにパース
            remarks: item.remarks,
            author_memo: item.author_memo,
            layer: item.layer,
            has_under_layer_flg: item.hasUnderLayerFlg,
            second_items: estimateSecondItemListToSave
          });
        });

        setShowLinearProgress(true);
        setProgressFlg(true);

        if (params.id) {
          log.info(`update estimate to: ${press_btn} mode: ${viewMode}`);
          updateEstimate(
            params.id,
            documentNumber,
            constructSub,
            status,
            selectedDateValue,
            salesUser,
            outPutPdf ?? false,
            displayItemNumber ?? false,
            accumulationCharge,
            remarks,
            constructDays,
            clientName,
            honorificTitle,
            contractorName,
            clientChargeName,
            expireDate,
            termsOfTrade,
            estimateConditions,
            totalPrice,
            selectedFormatId,
            estimateItemListToSave,
            taxRule
          ).then(data => {
            if (data === 'Not logged in!') {
              changeLoggedInData('Not logged in!');
            } else {
              if (typeof data === 'string') {
                setErrorMessage(data);
                setProgressFlg(false);
                setOpen(true);
              } else {
                if (data.error) {
                  setErrorMessage(data.error);
                  setProgressFlg(false);
                  setShowLinearProgress(false);
                  setOpen(true);
                } else {
                  if (callback) {
                    callback(params.id);
                  } else {
                    setErrorMessage(data.message);
                    getListOfUsers();
                    getTheDetailsOfEstimateList(
                      Number(params.id),
                      goPreview,
                      excelExport
                    );
                  }
                }
              }
            }
          });
        } else {
          console.log(constructSub);
          log.info(`create estimate to: ${press_btn} mode: ${viewMode}`);
          createEstimate(
            history.location.state.constructId,
            documentNumber,
            constructSub,
            status,
            selectedDateValue,
            salesUser,
            outPutPdf ?? false,
            displayItemNumber ?? false,
            accumulationCharge,
            remarks,
            constructDays,
            clientName,
            honorificTitle,
            contractorName,
            clientChargeName,
            expireDate,
            termsOfTrade,
            estimateConditions,
            totalPrice,
            selectedFormatId,
            estimateItemListToSave,
            taxRule
          ).then(data => {
            if (data === 'Not logged in!') {
              changeLoggedInData('Not logged in!');
            } else {
              if (typeof data === 'string') {
                setErrorMessage(data);
                setProgressFlg(false);
                setOpen(true);
              } else {
                if (data.error) {
                  setErrorMessage(data.error);
                  setProgressFlg(false);
                  setShowLinearProgress(false);
                  setOpen(true);
                } else {
                  if (callback) {
                    callback(data.new_estimate_id);
                  } else {
                    setErrorMessage(data.message);
                    setOpenSuccess(true);
                    getListOfUsers();
                    getTheDetailsOfEstimateList(
                      data.new_estimate_id,
                      goPreview
                    );
                  }
                }
              }
            }
          });
        }
      }

      // ローカルストレージのデータを削除
      localStorage.removeItem(setKey);
      // 保存時間をリセット
      setSaveTime('');
    }
  };

  /**
   * 削除
   */
  const deleteEstimate = () => {
    if (unblockPageTransitionRef.current) {
      unblockPageTransitionRef.current();
    }
    deleteSingleEstimate(params.id).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            setTimeout(() => {
              history.goBack();
            }, 2000);
          }
        }
      }
    });
  };

  /**
   * 値をestimateItemListにセット
   * @param items
   */
  const setListOfItems = (items: any) => {
    // 階層別に振り分け
    const mainItems = items.filter((item: TEstimateBaseItem) => {
      return item.layer === 1;
    });
    const allSecondItems = items.filter((item: TEstimateBaseItem) => {
      return item.layer === 2;
    });
    const allThirdItems = items.filter((item: TEstimateBaseItem) => {
      return item.layer === 3;
    });
    const allFourthItems = items.filter((item: TEstimateBaseItem) => {
      return item.layer === 4;
    });
    const allFifthItems = items.filter((item: TEstimateBaseItem) => {
      return item.layer === 5;
    });

    const dataToSet: TEstimateItem[] = [];
    mainItems.forEach((item: TEstimateBaseItem) => {
      let secondItemsToSet: TEstimateItem[] = [];
      if (item.has_under_layer_flg) {
        //１階層が明細ありの場合、idが位置する２階層を取得
        const secondItems = allSecondItems.filter(
          (allSecondItem: TEstimateBaseItem) => {
            return allSecondItem.parent_item_id === item.id;
          }
        );
        if (secondItems.length > 0) {
          secondItems.forEach((secondItem: TEstimateBaseItem) => {
            let thirdItemsToSet: TEstimateItem[] = [];
            if (secondItem.has_under_layer_flg) {
              //２階層が明細ありの場合、idが位置する３階層を取得
              const thirdItems = allThirdItems.filter(
                (allThirdItem: TEstimateBaseItem) => {
                  return allThirdItem.parent_item_id === secondItem.id;
                }
              );
              if (thirdItems.length > 0) {
                thirdItems.forEach((thirdItem: TEstimateBaseItem) => {
                  let fourthItemsToSet: TEstimateItem[] = [];
                  if (thirdItem.has_under_layer_flg) {
                    //３階層が明細ありの場合、idが位置する４階層を取得
                    const fourthItems = allFourthItems.filter(
                      (allFourthItem: TEstimateBaseItem) => {
                        return allFourthItem.parent_item_id === thirdItem.id;
                      }
                    );
                    if (fourthItems.length > 0) {
                      fourthItems.forEach((fourthItem: TEstimateBaseItem) => {
                        let fifthItemsToSet: TEstimateItem[] = [];
                        if (fourthItem.has_under_layer_flg) {
                          //４階層が明細ありの場合、idが位置する５階層を取得
                          const fifthItems = allFifthItems.filter(
                            (allFifthItem: TEstimateBaseItem) => {
                              return (
                                allFifthItem.parent_item_id === fourthItem.id
                              );
                            }
                          );
                          if (fifthItems.length > 0) {
                            fifthItems.forEach(
                              (fifthItem: TEstimateBaseItem) => {
                                fifthItemsToSet.push(
                                  instantiateEstimateItemFromBase(
                                    fifthItem.id,
                                    fifthItem,
                                    []
                                  )
                                );
                              }
                            );
                          }
                        }
                        fourthItemsToSet.push(
                          instantiateEstimateItemFromBase(
                            fourthItem.id,
                            fourthItem,
                            fifthItemsToSet
                          )
                        );
                      });
                    }
                  }
                  thirdItemsToSet.push(
                    instantiateEstimateItemFromBase(
                      thirdItem.id,
                      thirdItem,
                      fourthItemsToSet
                    )
                  );
                });
              }
            }
            secondItemsToSet.push(
              instantiateEstimateItemFromBase(
                secondItem.id,
                secondItem,
                thirdItemsToSet
              )
            );
          });
        }
      }
      dataToSet.push(
        instantiateEstimateItemFromBase(item.id, item, secondItemsToSet)
      );
    });
    setEstimateItemList(dataToSet);
  };

  // ローカルストレージ用
  useEffect(() => {
    // ローカルストレージデータ取得
    const localStorageData = localStorage.getItem(setKey);

    // データが存在する場合
    if (localStorageData) {
      // データをjsonへ変換
      const jsonData = JSON.parse(localStorageData);

      // 現在時間と保存時間の差分を計算(ms)
      const ms = new Date().getTime() - new Date(jsonData.time).getTime();
      // 時間に変換
      const hour = Math.floor(ms / 3600000);

      // 保存時間
      let saveTime = jsonData.time;

      // 24時間以上経過している場合
      if (LOCAL_STORAGE_SAVE_TIME <= hour) {
        // 保存時間を空文字で初期化
        saveTime = '';
        // ローカルストレージのデータを削除
        localStorage.removeItem(setKey);
      }

      // 保存時間を設定
      setSaveTime(saveTime);
    }
  }, []);

  /**
   * 内訳合計（定価合計）算出
   */
  const getAggregateResults = () => {
    let copyAggregateResults = baseAggregateResults;
    estimateItemList.forEach(item => {
      copyAggregateResults.sellingPriceTotal += item.allSellingPrice
        ? item.allSellingPrice
        : 0;
      copyAggregateResults.costPriceTotal += item.allCostPrice
        ? item.allCostPrice
        : 0;
    });
    copyAggregateResults.taxTotal = calcTax(
      copyAggregateResults.sellingPriceTotal,
      tax,
      taxRule
    );
    copyAggregateResults.billingTotal =
      copyAggregateResults.sellingPriceTotal + copyAggregateResults.taxTotal;
    copyAggregateResults.grossProfitTotal =
      copyAggregateResults.sellingPriceTotal -
      copyAggregateResults.costPriceTotal;
    copyAggregateResults.grossProfitMarginTotal =
      copyAggregateResults.sellingPriceTotal !== 0
        ? Math.round(
            (copyAggregateResults.grossProfitTotal /
              copyAggregateResults.sellingPriceTotal) *
              100
          )
        : 0;
    copyAggregateResults.dailyUnitPrice =
      constructDays !== 0
        ? Math.round(copyAggregateResults.grossProfitTotal / constructDays)
        : 0;

    setTotalPrice(copyAggregateResults.sellingPriceTotal);
    setAggregateResults(copyAggregateResults);
  };

  const toggleImportEstimateMasterItem = (flag: boolean, i: number) => {
    let copyEstimateMasterItems: any = _.cloneDeep(estimateMasterItems);
    copyEstimateMasterItems[i].importFlag = !flag;
    setEstimateMasterItems(copyEstimateMasterItems);
    setEstimateMasterItemsSearch(copyEstimateMasterItems);
  };

  /**
   * 見積書マスタインポート
   */
  const importEstimateMasterItems = () => {
    const selectedItems = estimateMasterItems.filter(
      (obj: any) => obj.importFlag
    );

    const importItems: any = [];
    // 項目数のカウント
    let importLength: number = 0;

    selectedItems.forEach((item: TEstimateItem) => {
      importLength++;
      let secondItems: TEstimateItem[] = [];

      //２階層以下を持つ場合
      if (item.has_under_layer_flg && item.second_items.length > 0) {
        // 階層別に振り分け
        const allSecondItems = item.second_items.filter(
          (item: TEstimateBaseItem) => {
            return item.layer === 2;
          }
        );
        const allThirdItems = item.second_items.filter(
          (item: TEstimateBaseItem) => {
            return item.layer === 3;
          }
        );
        const allFourthItems = item.second_items.filter(
          (item: TEstimateBaseItem) => {
            return item.layer === 4;
          }
        );
        const allFifthItems = item.second_items.filter(
          (item: TEstimateBaseItem) => {
            return item.layer === 5;
          }
        );

        allSecondItems.forEach((secondItem: TEstimateBaseItem) => {
          importLength++;
          let thirdItems: TEstimateItem[] = [];
          if (secondItem.has_under_layer_flg) {
            //２階層が明細ありの場合、idが位置する３階層を取得
            const thirdMasterItems = allThirdItems.filter(
              (allThirdItem: TEstimateBaseItem) => {
                return allThirdItem.parent_item_id === secondItem.id;
              }
            );
            if (thirdMasterItems.length > 0) {
              //カスタムフォーマットを選択中で３階層以下を持っていない場合にアラートを出す
              if (!hasThirdLayer && selectedFormatId) {
                setCustomFormatAlertModal(true);
              }

              thirdMasterItems.forEach((thirdItem: TEstimateBaseItem) => {
                importLength++;
                let fourthItems: TEstimateItem[] = [];
                if (thirdItem.has_under_layer_flg) {
                  //３階層が明細ありの場合、idが位置する４階層を取得
                  const fourthMasterItems = allFourthItems.filter(
                    (allFourthItem: TEstimateBaseItem) => {
                      return allFourthItem.parent_item_id === thirdItem.id;
                    }
                  );
                  if (fourthMasterItems.length > 0) {
                    fourthMasterItems.forEach(
                      (fourthItem: TEstimateBaseItem) => {
                        importLength++;
                        let fifthItems: TEstimateItem[] = [];
                        if (fourthItem.has_under_layer_flg) {
                          //４階層が明細ありの場合、idが位置する５階層を取得
                          const fifthMasterItems = allFifthItems.filter(
                            (allFifthItem: TEstimateBaseItem) => {
                              return (
                                allFifthItem.parent_item_id === fourthItem.id
                              );
                            }
                          );
                          fifthMasterItems.forEach(
                            (fifthItem: TEstimateBaseItem) => {
                              importLength++;
                              fifthItems.push(
                                instantiateEstimateItemFromBase(
                                  uuidv4(),
                                  fifthItem,
                                  []
                                )
                              );
                            }
                          );
                        }
                        fourthItems.push(
                          instantiateEstimateItemFromBase(
                            uuidv4(),
                            fourthItem,
                            fifthItems
                          )
                        );
                      }
                    );
                  }
                }
                thirdItems.push(
                  instantiateEstimateItemFromBase(
                    uuidv4(),
                    thirdItem,
                    fourthItems
                  )
                );
              });
            }
          }
          secondItems.push(
            instantiateEstimateItemFromBase(uuidv4(), secondItem, thirdItems)
          );
        });
      }
      importItems.push(
        instantiateEstimateItemFromBase(uuidv4(), item, secondItems)
      );
    });

    // 現在の見積書の項目数とインポートの項目数を合計し最大項目数を超えるかどうか確認
    if (itemTotalCount + importLength > ESTIMATE_TOTAL_ITEM_MAX) {
      setErrorMessage(
        `${ESTIMATE_TOTAL_ITEM_MAX}項目以上の見積書は作成できません。`
      );
      setOpen(true);
    } else {
      if (estimateItemList.length + importItems.length <= ESTIMATE_ITEM_MAX) {
        setEstimateItemList([...estimateItemList, ...importItems]);
      } else {
        setErrorMessage(
          `大項目の登録可能件数の上限は${ESTIMATE_ITEM_MAX}件です。`
        );
        setOpen(true);
      }
      console.log('after adding estimate item', estimateItemList);
    }
  };

  useEffect(() => {
    if (params.id) {
      // 見積書に紐づく追加原価、粗利を取得
      fetchAdditionalCost(params.id, setAdditionalParam);
    }
  }, [params.id]);

  useEffect(() => {
    getListOfUsers();
    if (params.id) {
      getTheDetailsOfEstimateList();
    } else {
      initializeEstimate();
    }
    // 無限ループになるためeslint disable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getListOfUsers, initializeEstimate, params.id]);

  useEffect(() => {
    getAggregateResults();
    // 無限ループになるためeslint disable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estimateItemList, constructDays, taxRule]);

  useEffect(() => {
    const date = new Date();
    setSelectedDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setSelectedDateValue(finaldate);
  }, []);

  useEffect(() => {
    unblockPageTransitionRef.current = history.block((loc, action) => {
      if (PAGE_TRANSITION_ALLOW_LIST.some(regex => regex.test(loc.pathname))) {
        unblockPageTransitionRef.current();
        return;
      }
      const onConfirm =
        action === 'POP'
          ? history.goBack
          : action === 'PUSH'
          ? () => history.push(loc.pathname, history.location.state)
          : action === 'REPLACE'
          ? () => history.replace(loc.pathname, history.location.state)
          : () => {};
      setSaveConfirmModalState({
        type: 'open',
        onConfirm: () => {
          unblockPageTransitionRef.current();
          onConfirm();
        }
      });
      return false;
    });
    return () => {
      if (unblockPageTransitionRef.current) {
        unblockPageTransitionRef.current();
      }
    };
  }, [history, saveConfirmModalState]);

  // パンくずリスト表示パターン(編集)
  let patternName = 'estimates_edit';

  // 新規作成画面のモードの場合
  if (location.pathname.match('create')) {
    // パンくずリスト表示パターン(新規)
    patternName = 'estimates_create';
  }

  const patternState: TTopicPathState = {};
  patternState['/estimates'] = history.location.state;

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  /**
   * ローカルストレージへの保存処理
   * @param key
   * @param value
   */
  const setLocalStorage: TSetLocalStorage = (
    key:
      | 'code'
      | 'constructSub'
      | 'status'
      | 'salesUser'
      | 'selectedDate'
      | 'accumulationCharge'
      | 'estimateConditions'
      | 'constructDays'
      | 'clientName'
      | 'honorificTitle'
      | 'contractorName'
      | 'clientChargeName'
      | 'expireDate'
      | 'termsOfTrade'
      | 'remarks'
      | 'estimateItemList',
    value: string
  ) => {
    // 設定データ
    let setData = {
      code: '',
      constructSub: '',
      status: '',
      salesUser: '',
      selectedDate: '',
      accumulationCharge: '',
      estimateConditions: '',
      constructDays: '',
      clientName: '',
      honorificTitle: '',
      contractorName: '',
      clientChargeName: '',
      expireDate: '',
      termsOfTrade: '',
      remarks: '',
      estimateItemList: '',
      time: ''
    };

    // ローカルストレージのデータを取得
    const localStorageData = localStorage.getItem(setKey);

    // ローカルストレージのデータが存在する場合
    if (localStorageData) {
      // 設定データに取得した既存データを設定
      setData = JSON.parse(localStorageData);
    }

    // 対象のキーの値を更新
    setData[key] = value;

    // 保存時間を設定
    const now = new Date();
    const time = `${now.getFullYear()}/${('0' + (now.getMonth() + 1)).slice(
      -2
    )}/${('0' + now.getDate()).slice(-2)} ${('0' + now.getHours()).slice(
      -2
    )}:${('0' + now.getMinutes()).slice(-2)}:${('0' + now.getSeconds()).slice(
      -2
    )}`;
    setData.time = time;

    // ローカルストレージへ保存
    localStorage.setItem(setKey, JSON.stringify(setData));

    // 設定時間を更新
    setSaveTime(time);
  };

  /**
   * ローカルストレージの内容を反映
   */
  const reflectLocalStorage = () => {
    // ローカルストレージデータを取得
    const localStorageData = localStorage.getItem(setKey);

    // ローカルストレージデータが存在する場合
    if (localStorageData) {
      // 各値を取得
      const jsonData = JSON.parse(localStorageData);
      const code = jsonData.code;
      const status = jsonData.status;
      const salesUser = jsonData.salesUser;
      const selectedDate = jsonData.selectedDate;
      const accumulationCharge = jsonData.accumulationCharge;
      const estimateConditions = jsonData.estimateConditions;
      const constructDays = jsonData.constructDays;
      const clientName = jsonData.clientName;
      const honorificTitle = jsonData.honorificTitle;
      const contractorName = jsonData.contractorName;
      const clientChargeName = jsonData.clientChargeName;
      const expireDate = jsonData.expireDate;
      const termsOfTrade = jsonData.termsOfTrade;
      const remarks = jsonData.remarks;
      const estimateItemList = jsonData.estimateItemList;

      if (code) {
        setDocumentNumber(code);
      }

      if (status) {
        setStatus(parseInt(status));
      }

      if (salesUser) {
        setSalesUser(parseInt(salesUser));
      }

      if (selectedDate) {
        setSelectedDateValue(selectedDate);
        setSelectedDate(new Date(selectedDate));
      }

      if (accumulationCharge) {
        setAccumulationCharge(parseInt(accumulationCharge));
      }

      if (estimateConditions) {
        setEstimateConditions(estimateConditions);
      }

      if (constructDays) {
        setConstructDays(parseInt(constructDays));
      }

      if (clientName) {
        setClientName(clientName);
      }

      if (honorificTitle) {
        setHonorificTitle(honorificTitle);
      }

      if (contractorName) {
        setContractorName(contractorName);
      }

      if (clientChargeName) {
        setClientChargeName(clientChargeName);
      }

      if (expireDate) {
        setExpireDate(expireDate);
      }

      if (termsOfTrade) {
        setTermsOfTrade(termsOfTrade);
      }

      if (remarks) {
        setRemarks(remarks);
      }

      if (estimateItemList) {
        const copyEstimateItemList: any = _.cloneDeep(
          JSON.parse(estimateItemList)
        );
        setEstimateItemList(copyEstimateItemList);
      }
    }
  };

  /**
   * 実行予算ボタンのツールチップメッセージ
   */
  const workingBudgetButtonMsg = (isCreated: boolean) => {
    if (isCreated) {
      return '見積書を保存し、実行予算画面を開きます。';
    } else {
      return '見積書を保存し、実行予算を作成します。';
    }
  };

  const handleDocumentNumberChange = (text: string) => {
    let val = text;
    if (/[^A-Za-z0-9]/.test(val)) {
      alert('半角英数で入力してください。');
      val = val.replace(/[^A-Za-z0-9]/g, '');
    }
    if (val.length > 20) {
      alert('20文字以下で入力してください。');
    }
    setDocumentNumber(val);
  };

  // 工事件名のハンドラー
  const handleConstructTextareaChange = (text: string) => {
    const rawText = text;
    let cleanText = '';
    let charCount = 0; // 全体の文字数カウント
    let lineCharCount = 0; // 各行の文字数カウント
    let lineCount = 1; // 行数カウント

    for (let i = 0; i < rawText.length; i++) {
      // 文字が改行コードかチェック
      if (rawText[i] === '\n' || rawText[i] === '\r') {
        // Windowsの改行コード（\r\n）を考慮
        if (rawText[i] === '\r' && rawText[i + 1] === '\n') {
          i++;
        }
        lineCount++;
        lineCharCount = 0; // 各行の文字数カウントをリセット

        if (lineCount > 2) {
          alert('2行まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      } else {
        charCount++;
        lineCharCount++;

        // 改行がある場合のみ各行の30文字制限を適用
        if (lineCount > 1 && lineCharCount > 30) {
          alert('1行あたり30文字まで入力可能です');
          break;
        }

        // 全体の60文字制限
        if (charCount > 60) {
          alert('60文字まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      }
    }

    setConstructSub(cleanText);
  };

  return (
    <>
      <AppBarComponent patternName={patternName} patternState={patternState} />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              minHeight: window.innerHeight - 120
            }}
          >
            <div style={{ margin: 15 }}>
              <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity='error'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccess}
                autoHideDuration={4000}
                onClose={handleCloseSuccess}
              >
                <Alert onClose={handleCloseSuccess} severity='success'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Dialog
                open={openImportEstimateMasterDialog}
                onClose={handleCloseImportEstimateMasterDialog}
                scroll='paper'
                aria-labelledby='set_construct_title'
                aria-describedby='constructs'
                style={{ margin: '0 auto' }}
              >
                <DialogTitle id='set_construct_title'>
                  追加する見積書マスタを選択してください
                </DialogTitle>
                {dialogLoading ? (
                  <>
                    <Snackbar
                      open={open}
                      autoHideDuration={4000}
                      onClose={handleClose}
                    >
                      <Alert onClose={handleClose} severity='error'>
                        {errorMessage}
                      </Alert>
                    </Snackbar>
                    <LoadingComponent isFormGroup={true} />
                  </>
                ) : (
                  <DialogContent
                    dividers
                    style={{ width: '500px', height: '500px' }}
                  >
                    <DialogTitle id='set_construct_title'>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                          fontSize: '0.7rem',
                          marginBottom: 10,
                          color: '#808080'
                        }}
                      >
                        <Checkbox
                          style={{ padding: 4, transform: 'scale(0.7)' }}
                          checked={showAuthorMemo}
                          onChange={handleCheckboxChange}
                        />
                        <span>社内用メモを検索結果に表示する</span>
                      </div>
                      <div style={{ marginTop: 3 }}>
                        検索：
                        <div>
                          <input
                            placeholder='大項目'
                            style={{
                              backgroundColor: '#F3F3F3',
                              borderRadius: 5,
                              width: '49%',
                              border: `1px solid ${mainColor}`,
                              padding: 5
                            }}
                            onChange={(e: any) => {
                              handleTextValidation(
                                e.target.value,
                                20,
                                null,
                                null,
                                setName
                              );
                            }}
                          />
                          <input
                            placeholder='仕様'
                            style={{
                              backgroundColor: '#F3F3F3',
                              borderRadius: 5,
                              width: '49%',
                              border: `1px solid ${mainColor}`,
                              padding: 5,
                              marginLeft: 7
                            }}
                            onChange={(e: any) => {
                              setSpec(e.target.value);
                            }}
                          />
                          <input
                            placeholder='社内用メモ'
                            style={{
                              marginTop: 7,
                              backgroundColor: '#F3F3F3',
                              borderRadius: 5,
                              width: '49%',
                              border: `1px solid ${mainColor}`,
                              padding: 5
                            }}
                            onChange={(e: any) => {
                              setAuthorMemo(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </DialogTitle>

                    <DialogContentText id='constructs'>
                      <List>
                        {estimateMasterItems.map((item: any, index: number) => (
                          <ListItem
                            button
                            selected={item.importFlag}
                            onClick={() => {
                              toggleImportEstimateMasterItem(
                                item.importFlag,
                                index
                              );
                            }}
                          >
                            <Checkbox
                              checked={item.importFlag}
                              color='primary'
                              style={{ marginRight: 16 }}
                              value={item.importFlag}
                            />
                            <ListItemText>
                              {item.name} - {item.spec || '仕様'} -{' '}
                              {showAuthorMemo &&
                                (item.author_memo || '社内用メモ')}
                            </ListItemText>
                          </ListItem>
                        ))}
                      </List>
                    </DialogContentText>
                  </DialogContent>
                )}
                <DialogActions>
                  <Button
                    onClick={handleCloseImportEstimateMasterDialog}
                    color='primary'
                  >
                    キャンセル
                  </Button>
                  <Button
                    onClick={() => {
                      importEstimateMasterItems();
                      handleCloseImportEstimateMasterDialog();
                    }}
                    color='primary'
                  >
                    追加する
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={openSelectFormatDialog}
                onClose={handleCloseSelectFormatDialog}
                scroll='paper'
                aria-labelledby='set_construct_title'
                aria-describedby='constructs'
              >
                <DialogTitle id='set_construct_title'>書式を選択</DialogTitle>
                {dialogLoading ? (
                  <>
                    <Snackbar
                      open={open}
                      autoHideDuration={4000}
                      onClose={handleClose}
                    >
                      <Alert onClose={handleClose} severity='error'>
                        {errorMessage}
                      </Alert>
                    </Snackbar>
                    <LoadingComponent isFormGroup={true} />
                  </>
                ) : (
                  <DialogContent dividers>
                    <List style={{ display: 'flex' }}>
                      <ListItem
                        style={{ display: 'block', padding: '10px' }}
                        button
                        selected={
                          selectedFormatIdOnModal === null ||
                          selectedFormatIdOnModal === undefined
                        }
                        onClick={() => setSelectedFormatIdOnModal(null)}
                      >
                        <img
                          style={{
                            width: 150,
                            height: 200,
                            objectFit: 'contain'
                          }}
                          alt={`item0`}
                          src={thumb1}
                        />
                        <ListItemText style={{ textAlign: 'center' }}>
                          CONOC標準
                        </ListItemText>
                      </ListItem>
                      {isCustomFormat ? (
                        <ListItem
                          style={{ display: 'block', padding: '10px' }}
                          button
                          selected={
                            selectedFormatIdOnModal !== null &&
                            selectedFormatIdOnModal !== undefined
                          }
                          onClick={() => setSelectedFormatIdOnModal(tenantId)}
                        >
                          <img
                            style={{
                              width: 150,
                              height: 200,
                              objectFit: 'contain'
                            }}
                            alt={`item${tenantId}`}
                            src={customFormatThumb as string}
                          />
                          <ListItemText style={{ textAlign: 'center' }}>
                            カスタム見積書
                          </ListItemText>
                        </ListItem>
                      ) : null}
                    </List>
                  </DialogContent>
                )}
                <DialogActions>
                  <Button
                    style={{
                      marginLeft: '15px',
                      marginBottom: '0px',
                      backgroundColor: '#52555f'
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={handleCloseSelectFormatDialog}
                  >
                    閉じる
                  </Button>
                  <Button
                    style={{
                      marginLeft: '15px',
                      marginBottom: '0px',
                      backgroundColor: '#52555f'
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      setSelectedFormatId(selectedFormatIdOnModal);
                      handleCloseSelectFormatDialog();
                      if (hasThirdLayer) {
                        if (selectedFormatIdOnModal !== null) {
                          setCustomFormatAlertModal(true);
                        }
                      }
                    }}
                  >
                    適用
                  </Button>
                </DialogActions>
              </Dialog>

              <div className='table-top-container-customer'>
                <Button
                  style={{
                    minWidth: 90,
                    marginRight: 15,
                    color: '#758283',
                    backgroundColor: '#F5F5F5',
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={backToPreviousPage}
                  startIcon={<ArrowBackIcon />}
                >
                  戻る
                </Button>
              </div>

              {showLinearProgress && (
                <LinearProgress className={classes.progress} />
              )}

              <div style={{ backgroundColor: '#FFFFFF', marginBottom: 15 }}>
                <div
                  className='table-top-container-customer'
                  style={{ display: 'flex' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'baseline'
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 'bold',
                        padding: 15,
                        paddingBottom: 0,
                        fontSize: 24
                      }}
                    >
                      {params.id ? '見積書編集' : '見積書作成'}
                    </div>
                    <div>
                      書式：
                      {selectedFormatId !== null &&
                      selectedFormatId >= 1 &&
                      customFormatPdf !== null &&
                      customFormatPdf.length > 0
                        ? 'カスタム見積書'
                        : 'CONOC標準'}
                    </div>
                    <Button
                      style={{
                        marginLeft: '15px',
                        marginBottom: '0px',
                        backgroundColor: '#52555f'
                      }}
                      variant='contained'
                      color='secondary'
                      onClick={() => {
                        setSelectedFormatIdOnModal(selectedFormatId);
                        setOpenSelectFormatDialog(true);
                      }}
                    >
                      変更
                    </Button>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'baseline'
                    }}
                  >
                    {saveTime && (
                      <>
                        <AlertModal
                          reflectModal={reflectModal}
                          setReflectModal={setReflectModal}
                          reflectLocalStorage={reflectLocalStorage}
                        />
                        <Button
                          style={{ color: '#0000FF', marginRight: 10 }}
                          onClick={() => {
                            setReflectModal(true);
                          }}
                        >{`最終保存：${saveTime}`}</Button>
                      </>
                    )}
                  </div>
                  {/* カスタムフォーマット選択時、三階層を持つ場合のアラート */}
                  <CustomFormatAlertModal
                    customFormatAlertModal={customFormatAlertModal}
                    setCustomFormatAlertModal={setCustomFormatAlertModal}
                  />
                  {/* 全体モードの推奨数オーバーのアラート */}
                  <ChangeModeAlertModal
                    currentMode={viewMode}
                    changeModeAlertModal={changeModeAlertModal}
                    setChangeModeAlertModal={setChangeModeAlertModal}
                    setViewMode={setViewMode}
                  />
                  {/* 帳票削除のアラート */}
                  <DocumentDeleteModal
                    documentType={'見積書'}
                    documentDeleteModal={documentDeleteModal}
                    setDocumentDeleteModal={setDocumentDeleteModal}
                    deleteDocument={deleteEstimate}
                  />
                  <SaveConfirmModal
                    open={saveConfirmModalState.type === 'open'}
                    onSave={() => {
                      updateOrCreateEstimateDetails(
                        false,
                        false,
                        undefined,
                        () => {
                          setShowLinearProgress(false);
                          setProgressFlg(false);
                          if (saveConfirmModalState.type === 'open') {
                            saveConfirmModalState.onConfirm();
                          }
                        }
                      );
                    }}
                    onNoSave={() => {
                      if (saveConfirmModalState.type === 'open') {
                        saveConfirmModalState.onConfirm();
                      }
                    }}
                    onCancel={() => {
                      setSaveConfirmModalState({ type: 'closed' });
                    }}
                  />
                  {/* 項目のコピーモーダル */}
                  {copyModalState.type === 'open' && (
                    <CopyModal
                      copyToList={getCopyToList(
                        estimateItemList,
                        copyModalState.copyItem.layer - 1
                      )}
                      copyItem={copyModalState.copyItem}
                      copyModal={copyModalState.type === 'open'}
                      copyModalDispatch={copyModalDispatch}
                    />
                  )}
                </div>

                <Grid container>
                  <Grid item xs={matches2 ? 4 : 12}>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          見積書番号{params.id && <span>*</span>}
                        </div>
                        <CustomTooltip
                          title={
                            params.id
                              ? tooltipContents.EditEstimateCode
                              : tooltipContents.CreateNewEstimateCode
                          }
                          placement='top'
                          interactive
                        >
                          <HelpIcon style={{ color: 'white', marginLeft: 8 }} />
                        </CustomTooltip>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainer}>
                          <input
                            value={documentNumber}
                            type='text'
                            maxLength={20}
                            placeholder='半角英数字、20文字以内'
                            onChange={text => {
                              handleDocumentNumberChange(text.target.value);
                            }}
                            onBlur={text => {
                              setLocalStorage('code', text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>見積件名</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={constructSub}
                            placeholder='60文字以内、2行以内'
                            maxLength={60}
                            onChange={text => {
                              handleConstructTextareaChange(text.target.value);
                            }}
                            onBlur={text => {
                              setLocalStorage(
                                'constructSub',
                                text.target.value
                              );
                            }}
                            className={classes.input1}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          ステータス<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainerSelectBox}>
                          <select
                            value={status}
                            onChange={text => {
                              setStatus(parseInt(text.target.value));
                            }}
                            onBlur={text => {
                              setLocalStorage('status', text.target.value);
                            }}
                            className={classes.selectBoxStyle}
                            name='cars'
                            id='cars'
                            form='carform'
                          >
                            {/* <option value={0}>選択してください</option> */}
                            <option value={1}>作成中</option>
                            <option value={2}>変更</option>
                            <option value={3}>売上予定</option>
                            <option value={4}>受注</option>
                            <option value={5}>失注</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          営業担当<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainerSelectBox}>
                          <select
                            value={salesUser}
                            onChange={text => {
                              setSalesUser(parseInt(text.target.value));
                            }}
                            onBlur={text => {
                              setLocalStorage('salesUser', text.target.value);
                            }}
                            className={classes.selectBoxStyle}
                            form='carform'
                          >
                            <option value={0}>選択してください</option>
                            {getStaffSelectOptions(
                              userData,
                              initialSalesUserData
                            )}
                          </select>
                        </div>
                        <Checkbox
                          checked={outPutPdf}
                          onChange={outPutCheck}
                          color='default'
                        />
                        <CustomTooltip
                          title={tooltipContents.salesOutput}
                          placement='right'
                        >
                          <HelpIcon color='action' style={{ marginRight: 8 }} />
                        </CustomTooltip>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          積算担当<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainerSelectBox}>
                          <select
                            value={accumulationCharge}
                            onChange={text => {
                              setAccumulationCharge(
                                parseInt(text.target.value)
                              );
                            }}
                            onBlur={text => {
                              setLocalStorage(
                                'accumulationCharge',
                                text.target.value
                              );
                            }}
                            className={classes.selectBoxStyle}
                            form='carform'
                          >
                            <option value={0}>選択してください</option>
                            {getStaffSelectOptions(
                              userData,
                              initialAccountantUserData
                            )}
                          </select>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          見積提出日<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedDate}
                            onChange={handleDateChange}
                            id={'submission_date'}
                            emptyLabel={'日付を選択'}
                          />
                        </div>
                      </div>
                    </div>
                    {/* 消費税の小数点以下計算 */}
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          消費税の小数点以下
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                          }}
                        >
                          {/* 切捨て */}
                          <div
                            onClick={() => {
                              handleTaxRuleChange(TAX_RULE.FLOOR);
                            }}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              padding: 8
                            }}
                          >
                            <div className='checkbox'>
                              {taxRule === TAX_RULE.FLOOR && (
                                <div className='dot' />
                              )}
                            </div>
                            <div style={{ fontSize: 16, marginLeft: 5 }}>
                              切捨て
                            </div>
                          </div>

                          {/* 切上げ */}
                          <div
                            onClick={() => {
                              handleTaxRuleChange(TAX_RULE.CEIL);
                            }}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              padding: 8
                            }}
                          >
                            <div className='checkbox'>
                              {taxRule === TAX_RULE.CEIL && (
                                <div className='dot' />
                              )}
                            </div>
                            <div style={{ fontSize: 16, marginLeft: 5 }}>
                              切上げ
                            </div>
                          </div>

                          {/* 四捨五入 */}
                          <div
                            onClick={() => {
                              handleTaxRuleChange(TAX_RULE.ROUND);
                            }}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              padding: 8
                            }}
                          >
                            <div
                              className='checkbox'
                              style={{ borderColor: '' }}
                            >
                              {taxRule === TAX_RULE.ROUND && (
                                <div
                                  className='dot'
                                  style={{ backgroundColor: '' }}
                                />
                              )}
                            </div>
                            <div style={{ fontSize: 16, marginLeft: 5 }}>
                              四捨五入
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={matches2 ? 4 : 12}>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>工事日数</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputMainContainer}>
                          <div className={classes.inputContainer}>
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <input
                                value={
                                  Number(constructDays) === 0
                                    ? ''
                                    : constructDays
                                }
                                type='number'
                                min={0}
                                max={9999}
                                onChange={text => {
                                  const inputValue = text.target.value;
                                  if (inputValue == '') {
                                    setConstructDays(0);
                                  } else if (
                                    parseInt(inputValue) >= 0 &&
                                    parseInt(inputValue) <= 9999
                                  ) {
                                    setConstructDays(parseInt(inputValue));
                                  }
                                }}
                                onBlur={text => {
                                  setLocalStorage(
                                    'constructDays',
                                    text.target.value
                                  );
                                }}
                                className={classes.inputAlignRight}
                                onWheel={(e: any) => e.target.blur()}
                              />
                              <div style={{ marginLeft: 20 }}>日</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div
                        className={classes.textMainContainer}
                        style={{ height: 100 }}
                      >
                        <div className={classes.textContainer}>
                          請求先顧客名
                        </div>
                      </div>
                      <div className={classes.inputMainClientContainer}>
                        <div
                          className={classes.inputContainer}
                          style={{ width: '70%' }}
                        >
                          <textarea
                            value={clientName}
                            placeholder='40文字以内、2行以内'
                            maxLength={40}
                            onChange={text => {
                              handleTextValidation(
                                text.target.value,
                                40,
                                2,
                                null,
                                setClientName
                              );
                            }}
                            onBlur={text => {
                              setLocalStorage('clientName', text.target.value);
                            }}
                            className={classes.input1}
                            style={{ minHeight: 100, maxHeight: 120 }}
                          />
                        </div>
                        <div
                          className={classes.inputContainer}
                          style={{
                            width: '30%',
                            marginLeft: 0,
                            paddingRight: 0
                          }}
                        >
                          <select
                            value={honorificTitle}
                            onChange={text => {
                              setHonorificTitle(text.target.value);
                            }}
                            onBlur={text => {
                              setLocalStorage(
                                'honorificTitle',
                                text.target.value
                              );
                            }}
                            className={classes.selectBoxStyle}
                          >
                            {/* <option value={0}>選択してください</option> */}
                            <option value='御中'>御中</option>
                            <option value='様'>様</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>契約者名</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={contractorName}
                            type='text'
                            onChange={text => {
                              setContractorName(text.target.value);
                            }}
                            onBlur={text => {
                              setLocalStorage(
                                'contractorName',
                                text.target.value
                              );
                            }}
                            className={classes.input}
                            maxLength={50}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          顧客側担当者名
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={clientChargeName}
                            type='text'
                            onChange={text => {
                              setClientChargeName(text.target.value);
                            }}
                            onBlur={text => {
                              setLocalStorage(
                                'clientChargeName',
                                text.target.value
                              );
                            }}
                            className={classes.input}
                            maxLength={50}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          見積有効期限
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={expireDate}
                            type='text'
                            onChange={text => {
                              setExpireDate(text.target.value);
                            }}
                            onBlur={text => {
                              setLocalStorage('expireDate', text.target.value);
                            }}
                            className={classes.input}
                            maxLength={24}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>取引条件</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={termsOfTrade}
                            type='text'
                            onChange={text => {
                              setTermsOfTrade(text.target.value);
                            }}
                            onBlur={text => {
                              setLocalStorage(
                                'termsOfTrade',
                                text.target.value
                              );
                            }}
                            className={classes.input}
                            maxLength={24}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div
                      className={classes.subContainer}
                      style={{ marginBottom: 15 }}
                    >
                      <div className={classes.textMainContainer1}>
                        <div className={classes.textContainer1}>御見積条件</div>
                      </div>
                      <div className={classes.inputMainContainer1}>
                        <div className={classes.inputContainer}>
                          <textarea
                            placeholder='135文字、または8行以内'
                            value={estimateConditions}
                            maxLength={142}
                            onChange={event => {
                              const value = event.target.value;
                              setEstimateConditions(value);
                              // 変換中でない文字ペーストの場合にもバリデーションを実行
                              if (!isComposing) {
                                handleTextValidation(
                                  value,
                                  135,
                                  8,
                                  19,
                                  setEstimateConditions,
                                  '御見積条件',
                                  false
                                );
                              }
                            }}
                            onCompositionStart={() => setIsComposing(true)}
                            onCompositionEnd={(
                              event: React.CompositionEvent<HTMLTextAreaElement>
                            ) => {
                              setIsComposing(false);
                              const value = (
                                event.target as HTMLTextAreaElement
                              ).value;
                              handleTextValidation(
                                value,
                                135,
                                8,
                                19,
                                setEstimateConditions,
                                '御見積条件',
                                false
                              );
                            }}
                            onBlur={event => {
                              setLocalStorage(
                                'estimateConditions',
                                event.target.value
                              );
                            }}
                            className={classes.input1}
                            style={{ maxHeight: 250 }}
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={matches2 ? 4 : 12}
                    style={{ paddingRight: matches2 ? 15 : 0 }}
                  >
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div
                      className={classes.subContainer}
                      style={{ marginBottom: 15 }}
                    >
                      <div className={classes.textMainContainer1}>
                        <div className={classes.textContainer1}>摘要</div>
                      </div>
                      <div className={classes.inputMainContainer1}>
                        <div className={classes.inputContainer}>
                          <textarea
                            placeholder='115文字、または4行以内'
                            value={remarks}
                            maxLength={119}
                            onChange={event => {
                              const value = event.target.value;
                              setRemarks(value);
                              // 変換中でない文字ペーストの場合にもバリデーションを実行
                              if (!isComposing) {
                                handleTextValidation(
                                  value,
                                  115,
                                  4,
                                  28,
                                  setRemarks,
                                  '摘要',
                                  false
                                );
                              }
                            }}
                            onCompositionStart={() => setIsComposing(true)}
                            onCompositionEnd={(
                              event: React.CompositionEvent<HTMLTextAreaElement>
                            ) => {
                              setIsComposing(false);
                              const value = (
                                event.target as HTMLTextAreaElement
                              ).value;
                              handleTextValidation(
                                value,
                                115,
                                4,
                                28,
                                setRemarks,
                                '摘要',
                                false
                              );
                            }}
                            onBlur={event => {
                              setLocalStorage('remarks', event.target.value);
                            }}
                            className={classes.input1}
                            style={{ maxHeight: 250 }}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer1}>作成者</div>
                      </div>
                      <div
                        className={classes.inputMainContainer}
                        style={{ display: 'flex' }}
                      >
                        <div
                          className={`${classes.fixedTextContainer} ${classes.multiColCell}`}
                          style={{
                            width: '50%',
                            borderRight: '1px #CCCCCC solid'
                          }}
                        >
                          {createdUser}
                        </div>
                        <div
                          className={`${classes.fixedTextContainer} ${classes.multiColCell}`}
                          style={{ width: '50%' }}
                        >
                          {createdAt}
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer1}>修正者</div>
                      </div>
                      <div
                        className={classes.inputMainContainer}
                        style={{ display: 'flex' }}
                      >
                        <div
                          className={`${classes.fixedTextContainer} ${classes.multiColCell}`}
                          style={{
                            width: '50%',
                            borderRight: '1px #CCCCCC solid'
                          }}
                        >
                          {updatedUser}
                        </div>
                        <div
                          className={`${classes.fixedTextContainer} ${classes.multiColCell}`}
                          style={{ width: '50%' }}
                        >
                          {updatedAt}
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>

                <div style={{ height: 10, backgroundColor: '#FFFFFF' }}></div>
              </div>

              <div style={{ backgroundColor: '#FFFFFF' }}>
                <div style={{ padding: 15 }}>
                  <TableContainer
                    component={Paper}
                    style={{ marginBottom: 15 }}
                  >
                    <SummaryTable
                      aggregateResults={aggregateResults}
                      additionalParam={additionalParam}
                    />
                  </TableContainer>

                  <EstimateItems
                    estimateItemList={estimateItemList}
                    setEstimateItemList={setEstimateItemList}
                    estimateInfo={{
                      constructId: constructId,
                      createUserId: createduserId,
                      salesUserId: salesUser,
                      clientName: clientName,
                      clientChargeName: clientChargeName
                    }}
                    handleError={(message: string) => {
                      setErrorMessage(message);
                      setOpen(true);
                    }}
                    handleSuccess={(message: string) => {
                      setErrorMessage(message);
                      setOpenSuccess(true);
                    }}
                    setProgressFlg={setProgressFlg}
                    setLocalStorage={setLocalStorage}
                    setCopyItem={setCopyItem}
                    copyModalState={copyModalState}
                    copyModalDispatch={copyModalDispatch}
                    setCustomFormatOverLayerFlg={setHasThirdLayer}
                    setChangeModeAlertModal={setChangeModeAlertModal}
                    setSaveConfirmModalState={setSaveConfirmModalState}
                    itemTotalCount={itemTotalCount}
                    setItemTotalCount={setItemTotalCount}
                    viewMode={viewMode}
                    setViewMode={setViewMode}
                    setOpenImportEstimateMasterModal={
                      setOpenImportEstimateMasterDialog
                    }
                    displayItemNumber={displayItemNumber}
                    handleDisplayItemNumberChange={
                      handleDisplayItemNumberChange
                    }
                    redirectToOtherDocuments={(
                      callback: (estimateId: number) => void
                    ) => {
                      updateOrCreateEstimateDetails(
                        false,
                        false,
                        null,
                        estimateId => {
                          setShowLinearProgress(false);
                          setProgressFlg(false);
                          callback(estimateId);
                        }
                      );
                    }}
                  />
                </div>
              </div>

              <div style={{ height: 80 }}></div>
              <div
                className='save-btn-container'
                style={{
                  backgroundColor: '#FFFFFF',
                  position: 'fixed',
                  bottom: 0,
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  padding: 20
                }}
              >
                <div>
                  {params.id && (
                    <>
                      <Button
                        style={{
                          marginRight: 15,
                          marginBottom: 0,
                          backgroundColor: buttonColor
                        }}
                        variant='contained'
                        color='primary'
                        onClick={() => {
                          updateOrCreateEstimateDetails(false, true);
                        }}
                      >
                        エクセルファイルのエクスポート
                      </Button>
                    </>
                  )}
                  <CustomTooltip
                    title={tooltipContents.preview}
                    placement='top'
                  >
                    <Button
                      style={{ marginRight: 15, backgroundColor: buttonColor }}
                      variant='contained'
                      color='primary'
                      disabled={showLinearProgress}
                      onClick={() => {
                        updateOrCreateEstimateDetails(true, false);
                      }}
                    >
                      プレビュー
                    </Button>
                  </CustomTooltip>
                  <CustomTooltip
                    title={workingBudgetButtonMsg(additionalParam.id > 0)}
                    placement='top'
                  >
                    <Button
                      style={{ marginRight: 15, backgroundColor: buttonColor }}
                      variant='contained'
                      color='primary'
                      onClick={() => {
                        onClickWorkingBudget(additionalParam.id);
                      }}
                    >
                      {additionalParam.id > 0 ? '実行予算' : '実行予算作成'}
                    </Button>
                  </CustomTooltip>
                  <Button
                    style={{
                      marginRight: params.id ? 15 : 30,
                      backgroundColor: buttonColor
                    }}
                    variant='contained'
                    color='primary'
                    disabled={showLinearProgress}
                    onClick={() => {
                      updateOrCreateEstimateDetails(false, false);
                    }}
                  >
                    保存
                  </Button>
                  {params.id && (
                    <Button
                      style={{
                        color: '#758283',
                        backgroundColor: '#F5F5F5',
                        marginRight: 30
                      }}
                      variant='contained'
                      color='primary'
                      onClick={() => {
                        setDocumentDeleteModal(true);
                      }}
                    >
                      削除
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
